import { fontSize, minBreakpoints, theme } from '@noths/polaris-client-ribbons-base';
import { inset, mediaQuery, pxToRem } from '@noths/polaris-client-styles';
import { css } from 'styled-components';

const { text, fonts } = theme;

export const expandingButton = css`
  ${fontSize(text.BODY.SM)};
  align-items: center;
  background-color: #fff;
  border-radius: 0.25rem;
  border: ${pxToRem(1)} solid var(--brand-purple-base);
  bottom: ${pxToRem(4)};
  color: var(--brand-purple-base);
  cursor: pointer;
  display: flex;
  font-family: ${fonts.PRIMARY_SEMIBOLD.family};
  font-weight: ${fonts.PRIMARY_SEMIBOLD.weight};
  justify-content: center;
  left: 0;
  margin: 0 auto;
  max-height: ${pxToRem(36)};
  max-width: ${pxToRem(181)};
  padding: ${inset(36, 6)};
  position: absolute;
  right: 0;
  width: 100%;
  z-index: 200;
`;

export const expandingButtonDividerContainer = css`
  bottom: ${pxToRem(20)};
  height: ${pxToRem(1)};
  left: 0;
  position: absolute;
  right: 0;
  width: 100%;
  z-index: 100;
`;

export const expandingButtonDivider = css`
  border: none;
  border-bottom: ${pxToRem(1)} solid var(--neutral-black-30);
  grid-column: 1 / -1;
  margin: auto;
  width: 100%;

  ${mediaQuery(
    { min: minBreakpoints.L },
    css`
      grid-column: 2 / -2;
    `,
  )}
`;
